module.exports = __webpack_public_path__ + "media/images/cardboard-bg-03-7aa88568c15f79b16be07877a4db26bd.png";